import createReducer from 'utils/redux/createReducer'
import * as R from 'ramda'

const initialState = []

export default createReducer(initialState, {
	NEW_TENANT  : (currentState) => ([...currentState, ""])
  , DELETE_NEW_TENANT : (currentState, action) =>(
		R.remove(action.data, 1, currentState)
  )
})



// WEBPACK FOOTER //
// ./src/reducers/newTenants.js